import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon, EditIcon, TrashIcon } from '../../components/icons/Icons';
import api from '../../services/api';
import AdminLayout from './AdminLayout';

const Posts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const response = await api.get('/blog/admin/all');
      setPosts(response.data);
    } catch (error) {
      console.error('Failed to fetch posts:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this post?')) return;

    try {
      await api.delete(`/blog/${id}`);
      setPosts(posts.filter(p => p.id !== id));
    } catch (error) {
      alert('Failed to delete post');
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <h1 className="admin-page-title">Blog Posts</h1>
        <Link to="/admin/posts/new" className="btn btn-primary">
          <PlusIcon size={18} /> New Post
        </Link>
      </div>

      <div className="admin-card">
        {loading ? (
          <p style={{ padding: '40px', textAlign: 'center', color: 'var(--text-light)' }}>
            Loading posts...
          </p>
        ) : posts.length === 0 ? (
          <p style={{ padding: '40px', textAlign: 'center', color: 'var(--text-light)' }}>
            No posts yet. Create your first post!
          </p>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Status</th>
                <th>Author</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {posts.map(post => (
                <tr key={post.id}>
                  <td>
                    <strong>{post.title}</strong>
                  </td>
                  <td>
                    <span className={`status-badge status-${post.status}`}>
                      {post.status}
                    </span>
                  </td>
                  <td>{post.author || 'Unknown'}</td>
                  <td>{formatDate(post.created_at)}</td>
                  <td>
                    <div className="admin-table-actions">
                      <Link to={`/admin/posts/${post.id}`} className="admin-btn-icon admin-btn-edit">
                        <EditIcon size={16} />
                      </Link>
                      <button 
                        onClick={() => handleDelete(post.id)} 
                        className="admin-btn-icon admin-btn-delete"
                      >
                        <TrashIcon size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </AdminLayout>
  );
};

export default Posts;
